<!-- IMPORTANT! - For concistency please use the following structure for future development -->
<!-- <div class="user-settings-tab-panel-wrapper">
    <div class="user-settings-control-row" fxLayout="row">
        <div class="row-content" fxflex="80%" fxlayout="column">
            <span [ngClass]="{'disabled': className}" class="user-settings-control-row_title">Setting Title</span>
            <p class="user-settings-control-row_description">Setting Description</p>
        </div>
        <div class="setting_toggle" fxflex="20%" fxlayout="row" fxlayoutalign="center">
            <bfx-toggle></bfx-toggle>
        </div>
    </div>
</div> -->

<div class="userSettings-loading-message" *ngIf="!ready" fxFlexFill>Loading...</div>
<div class="user-settings-component-container">
  <div
    class="user-settings-control-row"
    style="display: flex; box-sizing: border-box; flex-direction: row"
    *ngIf="ready"
  >
    <div
      class="row-content"
      fxflex="80%"
      fxlayout="column"
      style="
        flex: 1 1 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        max-width: 80%;
      "
    >
      <span [ngClass]="{'disabled': buyAndSell === false}" class="user-settings-control-row_title"
        >Enable Buy/Sell Highlighting</span
      >
      <p class="user-settings-control-row_description">
        Enables the green/red highlights for Buy and Sell orders.
      </p>
    </div>
    <div
      class="setting_toggle"
      fxflex="20%"
      fxlayout="row"
      fxlayoutalign="center"
      style="
        box-sizing: border-box;
        flex: 1 1 100%;
        display: flex;
        flex-direction: row;
        place-content: stretch center;
        max-width: 20%;
      "
    >
      <bfx-toggle
        [checked]="buyAndSell"
        [disabled]="disableBuyAndSell"
        (change)="enableBuyAndSellToggle($event)"
      >
      </bfx-toggle>
    </div>
  </div>
</div>
